import { get } from 'lodash';

export const getFileUploadFeatureFromConfig = (state, path) => get(state.features, path, {});
export const getMaxItemsPerChunk = (state, path) => get(state.features, path, 100);
export const getMaxThreads = (state, path) => get(state.features, path, 1);
